<script setup>
import { useAttrs } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  buttonText: {
    type: String,
    default: '',
  },
  trailingIcon: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
});

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
</script>

<template>
  <div class="relative">
    <Button
      v-bind="attrs"
      ghost
      slate
      sm
      no-animation
      :icon="icon"
      :trailing-icon="trailingIcon"
    >
      <span class="min-w-0 truncate">{{ buttonText }}</span>
    </Button>
    <slot name="dropdown" />
  </div>
</template>
